module.exports = __webpack_public_path__ + "img/work.94db290e.svg";